import { ObjectExt } from '../../util';
export const stroke = {
    qualify: ObjectExt.isPlainObject,
    set(stroke, { view }) {
        return `url(#${view.graph.defineGradient(stroke)})`;
    },
};
//# sourceMappingURL=stroke.js.map